module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraLight.b70ef3d.ttf";